// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
// import "channels" // do not want this on all pages

require('datatables.net-bs4')
require('select2')

require('dragscroll')

import "chartkick/chart.js"

Rails.start()
// Turbolinks.start()
ActiveStorage.start()

import JQuery from 'jquery';
window.$ = window.JQuery = JQuery
window.jQuery = window.JQuery = JQuery
import "bootstrap";

import 'select2'

import '../stylesheets/application'

const images = require.context('../images'  , true)

import "controllers"

// require("trix")
require("@rails/actiontext")

import "./youtube"

import Swal from 'sweetalert2';
window.$Swal = Swal

import {TabulatorFull as Tabulator} from 'tabulator-tables';
window.$Tabulator = Tabulator

import Cropper from 'cropperjs';
window.$Cropper = Cropper

// Receive platform notifications (order/service) over the platform's ActionCable.
// Self-guards: only subscribes when a #notification-container is on the page.
import "../channels/platform_notifications"

// Sync PIN-lock state with the platform over its ActionCable.
// Self-guards: only subscribes when #mb-pinlock-channel is on the page.
import "../channels/platform_pin_lock"

$(document).ready( function () {
  $('label[required]').append(' <span class="text-danger">*</span>')
});

// Ctrl/Cmd + click and middle click on a data-remote link would open the endpoint in a
// new tab, which renders the format.js response as plain text. Treat both as plain clicks.
//
// These must run in the capture phase: @rails/ujs binds on document in Rails.start() above
// and its preventInsignificantClick calls stopImmediatePropagation() for meta-clicks and
// non-primary clicks, so any bubble-phase listener added later never runs.
function forcePlainRemoteClick(event) {
  const link = event.target.closest('a[data-remote="true"]')
  if (!link) return

  event.preventDefault()
  event.stopImmediatePropagation()
  link.click() // re-dispatch as a plain primary click so @rails/ujs handles it normally
}

document.addEventListener('click', function (event) {
  if (!event.ctrlKey && !event.metaKey) return
  forcePlainRemoteClick(event)
}, true)

// Middle click does not fire 'click' in modern browsers, it arrives as 'auxclick' with
// button 1. Right click (button 2) is left alone so the context menu still works.
document.addEventListener('auxclick', function (event) {
  if (event.button !== 1) return
  forcePlainRemoteClick(event)
}, true)
